// extracted by mini-css-extract-plugin
export var adjacentSlide = "_r0-9";
export var arrowButtonContainer = "_r0-5";
export var arrowButtonIcon = "_r0-6";
export var carouselArrowButton = "_r0-2";
export var carouselElementContainer = "_r0-1";
export var currentSlide = "_r0-8";
export var left = "_r0-3";
export var otherSlide = "_r0-a";
export var productCarouselContainer = "_r0-0";
export var right = "_r0-4";
export var sliderOverflow = "_r0-7";